import * as z from 'zod';

export const productAndServiceTemplateQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  sku: z.string(),
});

export type ProductAndServiceTemplateQueryLinkerSchema = z.infer<typeof productAndServiceTemplateQueryLinkerSchema>;
